import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { getDeviceInteraction } from './getDeviceInteraction';
import { getGameStaticData } from './getGameStaticData';
import { getAllPlays } from './getAllPlays';

const getGumboGameData = (state) => state?.gumbo?.gameData || {};
const getGumboGameStatus = (state) => getGumboGameData(state)?.status || {};

const getAbstractGameState = (state) => getGumboGameStatus(state)?.abstractGameState || '';
const getDetailedGameState = (state) => getGumboGameStatus(state)?.detailedState || '';

const getLinescore = (state) => state?.gumbo?.liveData?.linescore || {};
const getInningState = (state) => getLinescore(state)?.inningState;
const getCurrentInning = (state) => getLinescore(state)?.currentInning;
const getClientId = (state) => state?.userinfo?.clientId || '';
const getGameView = (state) => state?.views?.game_view || getAbstractGameState(state);
const getGameTab = (state) => state?.views?.game_tab;

const getTrackingConf = (state) => {
    const {
        config: {
            tracking = {}
        } = {}     
    } = state;

    return tracking;
};

const getCurrentBatter = (state) => {
    const {
        gumbo: {
            liveData: {
                linescore: {
                    offense   
                } = {},
                plays: {
                    currentPlay: {
                        matchup
                    } = {}
                } ={}
            } = {}
        } = {}
    } = state;

    return matchup?.batter?.person?.id || offense?.batter?.person?.id || '';
}

export const getTracking = createSelector(
    [ getTrackingConf, getDeviceInteraction ],
    ( tracking, { deviceInteraction } ) => (
        { tracking, deviceInteraction }
    )
);


export const getTrackingGameState = createSelector(
    [ getGameStaticData, getAbstractGameState, getDetailedGameState, getCurrentInning, getInningState, getClientId, getAllPlays, getCurrentBatter],
    ( gameStaticData,  gameState, gameStatus, currentInning, inningState, clientId, allPlays, batterId ) => ({
        ...gameStaticData,
        gameState,
        gameStatus,
        currentInning,
        inningState,
        clientId,
        allPlays,
        batterId
    })
);


export const getCurrentViewState = createSelector(
    [ getGameView, getGameTab],
    ( gameView, gameTab) => ({
        gameView,
        gameTab
    })
);
